<script>
    import { createEventDispatcher } from 'svelte'
    import ThinButton from '../../components/ThinButton/ThinButton.svelte'

    export let data

    const dispatch = createEventDispatcher ();
</script>

<style>
    .day-item {
        margin: 15px 0 3px 0;
        color: var(--text-secondary);
        font-size: 14px;
        font-weight: 600;
    }
    .day-item .lbl {
        float: left;
    }
    .day-item .ctrls {
        float: right;
        text-align: right;
    }
    .day-item.today .lbl {
        color: var(--text-selected);
    }
</style>

<div class="day-item clearfix" class:today={data.isToday}>
    <div class="lbl">
        {data.text} {#if data.isToday}(Oggi){/if}
    </div>
    <div class="ctrls">
        <ThinButton label="Invia notifica" busy={data.busy} 
            on:click={e => dispatch ('notify', { instant: data.date, bean: data })} />
    </div>
</div>